export const DEFAULT_TENANT_ID = 'AMWL';
export const SIX_HOURS = 6 * 60 * 60 * 1000;
export const TOP_LEVEL_APPLICATION = 'AEHR Client';

export const LG_ESITTER_CLIENT = 'LG';
export const SOLABORATE_ESITTER_CLIENT = 'SOLABORATE';
